import DiscountCode from './DiscountCode';
import { DiscountCodeProps, DiscountCodeValueProps } from './types';

export type { DiscountCodeProps, DiscountCodeValueProps };
export default DiscountCode;
